var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{class:_vm.showNav ? 'content-with-nav' : 'content'},[_c('router-view',{key:_vm.$route.fullPath})],1),(_vm.showNav)?_c('navigation-bar',{attrs:{"items":_vm.navItems}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }